const Loading = require('./world-locations.json')

export {
  Loading,
}